/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AgendaRouteImport } from './routes/agenda'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as GalaRouteImport } from './routes/gala'
import { Route as ParteneriRouteImport } from './routes/parteneri'
import { Route as SpeakeriRouteImport } from './routes/speakeri'
import { Route as TematicaRouteImport } from './routes/tematica'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminAgendaRouteImport } from './routes/_authenticated/admin/agenda'
import { Route as AuthenticatedAdminContinutRouteImport } from './routes/_authenticated/admin/continut'
import { Route as AuthenticatedAdminGalaRouteImport } from './routes/_authenticated/admin/gala'
import { Route as AuthenticatedAdminInscrieriRouteImport } from './routes/_authenticated/admin/inscrieri'
import { Route as AuthenticatedAdminParteneriRouteImport } from './routes/_authenticated/admin/parteneri'
import { Route as AuthenticatedAdminSecuritateRouteImport } from './routes/_authenticated/admin/securitate'
import { Route as AuthenticatedAdminSetariRouteImport } from './routes/_authenticated/admin/setari'
import { Route as AuthenticatedAdminSpeakeriRouteImport } from './routes/_authenticated/admin/speakeri'
import { Route as AuthenticatedAdminTemeRouteImport } from './routes/_authenticated/admin/teme'
import { Route as AuthenticatedAdminUtilizatoriRouteImport } from './routes/_authenticated/admin/utilizatori'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AgendaRoute = AgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const GalaRoute = GalaRouteImport.update({
  id: '/gala',
  path: '/gala',
  getParentRoute: () => rootRouteImport,
} as any)
const ParteneriRoute = ParteneriRouteImport.update({
  id: '/parteneri',
  path: '/parteneri',
  getParentRoute: () => rootRouteImport,
} as any)
const SpeakeriRoute = SpeakeriRouteImport.update({
  id: '/speakeri',
  path: '/speakeri',
  getParentRoute: () => rootRouteImport,
} as any)
const TematicaRoute = TematicaRouteImport.update({
  id: '/tematica',
  path: '/tematica',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminAgendaRoute =
  AuthenticatedAdminAgendaRouteImport.update({
    id: '/agenda',
    path: '/agenda',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminContinutRoute =
  AuthenticatedAdminContinutRouteImport.update({
    id: '/continut',
    path: '/continut',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminGalaRoute = AuthenticatedAdminGalaRouteImport.update({
  id: '/gala',
  path: '/gala',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminInscrieriRoute =
  AuthenticatedAdminInscrieriRouteImport.update({
    id: '/inscrieri',
    path: '/inscrieri',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminParteneriRoute =
  AuthenticatedAdminParteneriRouteImport.update({
    id: '/parteneri',
    path: '/parteneri',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminSecuritateRoute =
  AuthenticatedAdminSecuritateRouteImport.update({
    id: '/securitate',
    path: '/securitate',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminSetariRoute =
  AuthenticatedAdminSetariRouteImport.update({
    id: '/setari',
    path: '/setari',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminSpeakeriRoute =
  AuthenticatedAdminSpeakeriRouteImport.update({
    id: '/speakeri',
    path: '/speakeri',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminTemeRoute = AuthenticatedAdminTemeRouteImport.update({
  id: '/teme',
  path: '/teme',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminUtilizatoriRoute =
  AuthenticatedAdminUtilizatoriRouteImport.update({
    id: '/utilizatori',
    path: '/utilizatori',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agenda': typeof AgendaRoute
  '/auth': typeof AuthRoute
  '/contact': typeof ContactRoute
  '/gala': typeof GalaRoute
  '/parteneri': typeof ParteneriRoute
  '/speakeri': typeof SpeakeriRoute
  '/tematica': typeof TematicaRoute
  '/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/admin/agenda': typeof AuthenticatedAdminAgendaRoute
  '/admin/continut': typeof AuthenticatedAdminContinutRoute
  '/admin/gala': typeof AuthenticatedAdminGalaRoute
  '/admin/inscrieri': typeof AuthenticatedAdminInscrieriRoute
  '/admin/parteneri': typeof AuthenticatedAdminParteneriRoute
  '/admin/securitate': typeof AuthenticatedAdminSecuritateRoute
  '/admin/setari': typeof AuthenticatedAdminSetariRoute
  '/admin/speakeri': typeof AuthenticatedAdminSpeakeriRoute
  '/admin/teme': typeof AuthenticatedAdminTemeRoute
  '/admin/utilizatori': typeof AuthenticatedAdminUtilizatoriRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agenda': typeof AgendaRoute
  '/auth': typeof AuthRoute
  '/contact': typeof ContactRoute
  '/gala': typeof GalaRoute
  '/parteneri': typeof ParteneriRoute
  '/speakeri': typeof SpeakeriRoute
  '/tematica': typeof TematicaRoute
  '/admin/agenda': typeof AuthenticatedAdminAgendaRoute
  '/admin/continut': typeof AuthenticatedAdminContinutRoute
  '/admin/gala': typeof AuthenticatedAdminGalaRoute
  '/admin/inscrieri': typeof AuthenticatedAdminInscrieriRoute
  '/admin/parteneri': typeof AuthenticatedAdminParteneriRoute
  '/admin/securitate': typeof AuthenticatedAdminSecuritateRoute
  '/admin/setari': typeof AuthenticatedAdminSetariRoute
  '/admin/speakeri': typeof AuthenticatedAdminSpeakeriRoute
  '/admin/teme': typeof AuthenticatedAdminTemeRoute
  '/admin/utilizatori': typeof AuthenticatedAdminUtilizatoriRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/agenda': typeof AgendaRoute
  '/auth': typeof AuthRoute
  '/contact': typeof ContactRoute
  '/gala': typeof GalaRoute
  '/parteneri': typeof ParteneriRoute
  '/speakeri': typeof SpeakeriRoute
  '/tematica': typeof TematicaRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/_authenticated/admin/agenda': typeof AuthenticatedAdminAgendaRoute
  '/_authenticated/admin/continut': typeof AuthenticatedAdminContinutRoute
  '/_authenticated/admin/gala': typeof AuthenticatedAdminGalaRoute
  '/_authenticated/admin/inscrieri': typeof AuthenticatedAdminInscrieriRoute
  '/_authenticated/admin/parteneri': typeof AuthenticatedAdminParteneriRoute
  '/_authenticated/admin/securitate': typeof AuthenticatedAdminSecuritateRoute
  '/_authenticated/admin/setari': typeof AuthenticatedAdminSetariRoute
  '/_authenticated/admin/speakeri': typeof AuthenticatedAdminSpeakeriRoute
  '/_authenticated/admin/teme': typeof AuthenticatedAdminTemeRoute
  '/_authenticated/admin/utilizatori': typeof AuthenticatedAdminUtilizatoriRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agenda'
    | '/auth'
    | '/contact'
    | '/gala'
    | '/parteneri'
    | '/speakeri'
    | '/tematica'
    | '/admin'
    | '/admin/agenda'
    | '/admin/continut'
    | '/admin/gala'
    | '/admin/inscrieri'
    | '/admin/parteneri'
    | '/admin/securitate'
    | '/admin/setari'
    | '/admin/speakeri'
    | '/admin/teme'
    | '/admin/utilizatori'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agenda'
    | '/auth'
    | '/contact'
    | '/gala'
    | '/parteneri'
    | '/speakeri'
    | '/tematica'
    | '/admin/agenda'
    | '/admin/continut'
    | '/admin/gala'
    | '/admin/inscrieri'
    | '/admin/parteneri'
    | '/admin/securitate'
    | '/admin/setari'
    | '/admin/speakeri'
    | '/admin/teme'
    | '/admin/utilizatori'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/agenda'
    | '/auth'
    | '/contact'
    | '/gala'
    | '/parteneri'
    | '/speakeri'
    | '/tematica'
    | '/_authenticated/admin'
    | '/_authenticated/admin/agenda'
    | '/_authenticated/admin/continut'
    | '/_authenticated/admin/gala'
    | '/_authenticated/admin/inscrieri'
    | '/_authenticated/admin/parteneri'
    | '/_authenticated/admin/securitate'
    | '/_authenticated/admin/setari'
    | '/_authenticated/admin/speakeri'
    | '/_authenticated/admin/teme'
    | '/_authenticated/admin/utilizatori'
    | '/_authenticated/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AgendaRoute: typeof AgendaRoute
  AuthRoute: typeof AuthRoute
  ContactRoute: typeof ContactRoute
  GalaRoute: typeof GalaRoute
  ParteneriRoute: typeof ParteneriRoute
  SpeakeriRoute: typeof SpeakeriRoute
  TematicaRoute: typeof TematicaRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agenda': {
      id: '/agenda'
      path: '/agenda'
      fullPath: '/agenda'
      preLoaderRoute: typeof AgendaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gala': {
      id: '/gala'
      path: '/gala'
      fullPath: '/gala'
      preLoaderRoute: typeof GalaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parteneri': {
      id: '/parteneri'
      path: '/parteneri'
      fullPath: '/parteneri'
      preLoaderRoute: typeof ParteneriRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/speakeri': {
      id: '/speakeri'
      path: '/speakeri'
      fullPath: '/speakeri'
      preLoaderRoute: typeof SpeakeriRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tematica': {
      id: '/tematica'
      path: '/tematica'
      fullPath: '/tematica'
      preLoaderRoute: typeof TematicaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/agenda': {
      id: '/_authenticated/admin/agenda'
      path: '/agenda'
      fullPath: '/admin/agenda'
      preLoaderRoute: typeof AuthenticatedAdminAgendaRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/continut': {
      id: '/_authenticated/admin/continut'
      path: '/continut'
      fullPath: '/admin/continut'
      preLoaderRoute: typeof AuthenticatedAdminContinutRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/gala': {
      id: '/_authenticated/admin/gala'
      path: '/gala'
      fullPath: '/admin/gala'
      preLoaderRoute: typeof AuthenticatedAdminGalaRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/inscrieri': {
      id: '/_authenticated/admin/inscrieri'
      path: '/inscrieri'
      fullPath: '/admin/inscrieri'
      preLoaderRoute: typeof AuthenticatedAdminInscrieriRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/parteneri': {
      id: '/_authenticated/admin/parteneri'
      path: '/parteneri'
      fullPath: '/admin/parteneri'
      preLoaderRoute: typeof AuthenticatedAdminParteneriRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/securitate': {
      id: '/_authenticated/admin/securitate'
      path: '/securitate'
      fullPath: '/admin/securitate'
      preLoaderRoute: typeof AuthenticatedAdminSecuritateRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/setari': {
      id: '/_authenticated/admin/setari'
      path: '/setari'
      fullPath: '/admin/setari'
      preLoaderRoute: typeof AuthenticatedAdminSetariRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/speakeri': {
      id: '/_authenticated/admin/speakeri'
      path: '/speakeri'
      fullPath: '/admin/speakeri'
      preLoaderRoute: typeof AuthenticatedAdminSpeakeriRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/teme': {
      id: '/_authenticated/admin/teme'
      path: '/teme'
      fullPath: '/admin/teme'
      preLoaderRoute: typeof AuthenticatedAdminTemeRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/utilizatori': {
      id: '/_authenticated/admin/utilizatori'
      path: '/utilizatori'
      fullPath: '/admin/utilizatori'
      preLoaderRoute: typeof AuthenticatedAdminUtilizatoriRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
  }
}

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminAgendaRoute: typeof AuthenticatedAdminAgendaRoute
  AuthenticatedAdminContinutRoute: typeof AuthenticatedAdminContinutRoute
  AuthenticatedAdminGalaRoute: typeof AuthenticatedAdminGalaRoute
  AuthenticatedAdminInscrieriRoute: typeof AuthenticatedAdminInscrieriRoute
  AuthenticatedAdminParteneriRoute: typeof AuthenticatedAdminParteneriRoute
  AuthenticatedAdminSecuritateRoute: typeof AuthenticatedAdminSecuritateRoute
  AuthenticatedAdminSetariRoute: typeof AuthenticatedAdminSetariRoute
  AuthenticatedAdminSpeakeriRoute: typeof AuthenticatedAdminSpeakeriRoute
  AuthenticatedAdminTemeRoute: typeof AuthenticatedAdminTemeRoute
  AuthenticatedAdminUtilizatoriRoute: typeof AuthenticatedAdminUtilizatoriRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminAgendaRoute: AuthenticatedAdminAgendaRoute,
    AuthenticatedAdminContinutRoute: AuthenticatedAdminContinutRoute,
    AuthenticatedAdminGalaRoute: AuthenticatedAdminGalaRoute,
    AuthenticatedAdminInscrieriRoute: AuthenticatedAdminInscrieriRoute,
    AuthenticatedAdminParteneriRoute: AuthenticatedAdminParteneriRoute,
    AuthenticatedAdminSecuritateRoute: AuthenticatedAdminSecuritateRoute,
    AuthenticatedAdminSetariRoute: AuthenticatedAdminSetariRoute,
    AuthenticatedAdminSpeakeriRoute: AuthenticatedAdminSpeakeriRoute,
    AuthenticatedAdminTemeRoute: AuthenticatedAdminTemeRoute,
    AuthenticatedAdminUtilizatoriRoute: AuthenticatedAdminUtilizatoriRoute,
    AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AgendaRoute: AgendaRoute,
  AuthRoute: AuthRoute,
  ContactRoute: ContactRoute,
  GalaRoute: GalaRoute,
  ParteneriRoute: ParteneriRoute,
  SpeakeriRoute: SpeakeriRoute,
  TematicaRoute: TematicaRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
